import React from 'react'

function Landing() {
	return (
		<div className='landing__container'>
			<section
				id='landing__section'
				className='imagebg height-100 text-center'>
				<div
					className='background-image-holder'
					style={{
						opacity: '1',
						backgroundColor: 'rgba(0, 0, 0, 0)',
						backgroundPosition: 'initial',
						backgroundRepeat: 'repeat',
						backgroundAttachment: 'scroll',
						backgroundImage:
							'url("https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/etho-landing-bg.jpg")',
						backgroundSize: 'auto',
						backgroundOrigin: 'padding-box',
						backgroundClip: 'border-box'
					}}>
					<img
						alt=' '
						src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/etho-landing-bg.jpg'
					/>
				</div>
				<div className='container pos-vertical-center'>
					<div className='row justify-content-center'>
						<div className='col-lg-8'>
							<a href='/'>
								<img
									alt='symbol for The Etho'
									src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/TheEthoVisualLogo.png'
									style={{ maxHeight: '10rem' }}
								/>
								<img
									alt='symbol for The Etho'
									src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/TheEthoWordLogo-text.png'
									style={{ maxHeight: '5rem' }}
								/>
							</a>
						</div>
						<div className='col-lg-5 inline-titles'>
							<a
								href='http://www.alegreea.com/'
								className='btn--tertiary'
								target='_blank'
								rel='noopener noreferrer'>
								<h1
									className='extra-bold text--uppercase'
									style={{ color: '#6b8e22' }}>
									The Curated
								</h1>
							</a>
						</div>
						<div className='col-lg-9'>
							<p
								className='lead'
								style={{ color: 'rgb(0, 0, 0)' }}>
								Behind every great brand is a great woman: ours
								is Mother Earth.
								<br />
								We do more than just sell unique, curated
								products from around the world, we change lives.
								We believe we're better together &mdash; join
								the movement by shopping sustainably with
								confidence at The Etho. We have done the work so
								you don't have to.
							</p>
							<div className=''>
								<a
									className='btn btn--secondary btn--lg box-shadow'
									href='http://alegreea.com/'
									target='_blank'
									rel='noopener noreferrer'
									data-modal-index='0'
									style={{
										backgroundColor: 'var(--primary)'
									}}>
									<span className='btn__text'>Shop Now</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default Landing
